import {Component, OnInit, Input} from '@angular/core';
import {WindowRefService, ModePayService} from '@app/core';
import {size} from 'lodash';
import {AlertService} from '@app/shared/_alert/alert.service';
import {TranslateService} from '@ngx-translate/core';

@Component({
    selector: 'app-pay-express-form',
    templateUrl: './pay-express-form.component.html',
    styleUrls: ['./pay-express-form.component.scss']
})
export class PayExpressFormComponent implements OnInit {

    @Input() infoModePayement: Array<any>;
    payexpressToggledVal: any = null;
    payexpressTypeVal: any = null;
    isLoadingCardPay: boolean = false;
    constructor(private winRef: WindowRefService, private modePayService: ModePayService, private alertService: AlertService, public translate: TranslateService) {}

    ngOnInit() {
        if (size(this.infoModePayement) == 1) {
            this.payexpressToggledVal = {key: 0, info: this.infoModePayement[0]};
        }
    }


    submit(val: {key: number, info: {ruid: string}}) {
        let o = {type: 11, key: val.key};
        let g = this.modePayService.generatePayement(val.info.ruid, o, this.winRef.appConfigSite.idEtab);
        this.isLoadingCardPay = true;
        g.subscribe((result: {status: Number, response: {action: string}, }) => {
            if (!!result.status && !!result.response) {
                window.location.href = result.response.action;
            } else {
                this.translate.get('static.oups...uneerreuresestproduite,mercipourvotrecomprehenssion').subscribe((res: string) => {
                    this.alertService.clear();
                    this.alertService.error(res);
                    this.alertService.smoothscroll();
                });
            }
            this.isLoadingCardPay = false;
        });

    }

    /**
     * get taux de change
     * @returns number
     */
    get Cpercente(): number {
        return this.winRef.appConfigSite.Cpercente;
    }

    /**
     * get currency
     * @returns string
     */
    get Ccurrency(): string {
        return this.winRef.appConfigSite.Ccurrency;
    }

}
